
import React, { Component } from "react";
import { Collapse, Row, Col, Avatar, Tag, Typography } from "antd";
import { AlertOutlined, ToolOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { tagsBageStatus } from "./tagsBage";
import { ExpandedComponent } from "./expanded.helper";
import iconTrue from "../assets/images/icon/true.png";
import { TABLE_DATA } from "../Data/BankData";
const { Text } = Typography;


class TimeTableComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      highlightedTimes: [],
      expanded: false,
    };
    this.intervalId = null;
  }

  componentDidMount() {
    this.updateHighlight();
    this.intervalId = setInterval(this.updateHighlight, 60000); // 1 minute
  }

  componentWillUnmount() {
    if (this.intervalId) clearInterval(this.intervalId);
  }

  updateHighlight = () => {
    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    const shouldHighlight = TABLE_DATA.map(item => item.timeRange).filter(Boolean).filter((range) => {
      // ข้ามกรณีที่ไม่ใช่รูปแบบเวลา เช่น "Checking"
      if (!range.includes("-") || !range.includes(".")) return false;

      const [start, end] = range.split("-");
      const [startH, startM] = start.split(".").map(Number);
      const [endH, endM] = end.split(".").map(Number);

      const startTotal = startH * 60 + startM;
      const endTotal = endH * 60 + endM;

      if (startTotal > endTotal) { // กรณีข้ามคืน เช่น 23.00-02.00
        return currentMinutes >= startTotal || currentMinutes <= endTotal;
      }
      return currentMinutes >= startTotal && currentMinutes <= endTotal;
    });

    this.setState({ highlightedTimes: shouldHighlight });
  };

  renderTableRows = () => {
    const { highlightedTimes, expanded } = this.state;
    const { t } = this.props; // ดึง t มาจาก props (withTranslation)

    return TABLE_DATA.map((item, index) => {
      const isHighlighted = !item.timeRange ||
        item.timeRange === "-" ||
        highlightedTimes.includes(item.timeRange);

      const cellClass = `${isHighlighted ? "highlight-active" : "highlight"} ${item.className}`;

      return (
        <tr key={`${item.bankName}-${index}`} className={`${item.status === "Checking" ? "checking-row" : ""}`}>
          <td className={cellClass}>
            <span className="text-secondary">
              {item.timeRange ? t(item.timeRange) : t("ได้ตลอด")}
            </span>
          </td>
          <td className={cellClass}>
            <span className="text-secondary">
              <Avatar size={20} src={item.bankName === "truewallet" ? iconTrue : `https://assets.slipmate.ai/public/banks-logo/${item.bankLogo}`} />
              {" "}{t(item.bankName)} {" "}
              <Text className="d-block" italic><small style={{ fontWeight: 300, fontSize: 10, opacity: 0.7, marginLeft: 6 }}>{t(item.supported)}</small></Text>
            </span>
          </td>
          <td className={cellClass}>
            <Tag color={tagsBageStatus(item.type)}>{t(item.type)}</Tag>
          </td>
          <td className={cellClass}>
            {isHighlighted ? (
              <span style={{ color: tagsBageStatus(item.status), textTransform: "capitalize" }}>
                {item.status === "maintenance" ? <ToolOutlined /> : <i className={`bx bxs-circle ${item.status === "Ready" ? "bx-flashing" : ''}`} style={{ fontSize: "8px" }}></i>}  {t(item.status)}
              </span>
            ) : (
              <span style={{ color: "#ff4d4f" }}>
                <i className="bx bxs-circle" style={{ fontSize: "8px" }}></i> {t("Inactive")}
              </span>
            )}
          </td>
          <td className={cellClass} style={{ width: 300 }}>
            {item.note && (
              item.note.startsWith("*") ? (
                <small className="text-secondary" style={{ color: "#ccc" }}>{t(item.note)}</small>
              ) : (
                <ExpandedComponent row={1} expanded={expanded} text={t(item.note)} />
              ) 
            )}
          </td>
        </tr>
      );
    });
  };

  render() {
    const { t, contextHolder, onChange } = this.props;

    const mainHTML = (
      <>
        <p className="fs-sm-10 fs-11" style={{ marginLeft: "10px" }}>
          <ExpandedComponent
            key={`p-99`}
            row={1}
            expanded={this.state.expanded}
            text={t("ตารางนี้แสดงช่วงเวลาการเปิดใช้งานบัญชีเพื่อให้ระบบทำงานได้อย่างมีประสิทธิภาพ",)}
          />
        </p>
        <div className="body table-responsive">
          <table className="table timeTable table-bordered table-hover">
            <thead>
              <tr>
                <th className="fs-sm-10 text-truncate">{t("opening hours")} (GMT+7)</th>
                <th className="fs-sm-10">{t("Bank/Supported Account type")}</th>
                <th className="fs-sm-10">{t("Type")}</th>
                <th className="fs-sm-10">{t("Status")}</th>
                <th className="fs-sm-10">{t("note")}</th>
              </tr>
            </thead>
            <tbody>{this.renderTableRows()}</tbody>
          </table>
        </div>
        {/* ส่วน Note ท้ายตาราง... (เหมือนเดิม) */}
        <p className="text-secondary fs-sm-12 fs-12">
          <b>{t("note")} :</b>
        </p>
        <ul className="text-secondary fs-sm-10 fs-11">
          <li>
            <ExpandedComponent
              key={`li-note-100`}
              row={1}
              expanded={this.state.expanded}
              text={t("ช่วงเวลาทำการปกติของธนาคารส่วนใหญ่มักจะเป็นวันจันทร์ถึงวันศุกร์ ในช่วงเวลาประมาณ 8:30 น. ถึง 16:30 น. แต่อาจแตกต่างกันไปในแต่ละธนาคารและสาขา โปรดตรวจสอบกับธนาคารที่คุณใช้งาน")}
            />

          </li>
          <li>
            <ExpandedComponent
              key={`li-note-101`}
              row={1}
              expanded={this.state.expanded}
              text={t("ระบบธนาคารออนไลน์และตู้ ATM อาจมีการปิดปรับปรุงระบบเป็นครั้งคราว โปรดตรวจสอบประกาศจากธนาคาร")}
            />
          </li>
          <li>
            <ExpandedComponent
              key={`li-note-102`}
              row={1}
              expanded={this.state.expanded}
              text={t("คำแนะนำในตารางนี้เป็นเพียงแนวทางทั่วไป โปรดพิจารณาตามความสะดวกและความจำเป็นของท่าน")}
            />
          </li>
        </ul>
      </>
    );

    return (
      <Row>
        {contextHolder}
        <Col span={24}>
          <Collapse
            defaultActiveKey={["1"]}
            expandIconPosition="end"
            onChange={onChange}
            items={[{
              key: "1",
              label: <b><AlertOutlined /> {t("ธนาคารและช่วงเวลาเปิดใช้งาน")}</b>,
              children: mainHTML,
            }]}
          />
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  isContactModal: state.mailInboxReducer.isContactModal,
});

export default connect(mapStateToProps)(withTranslation()(TimeTableComponent));